import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import SubscriptionBasicInfoComponent from './subscription-basic-info.component';
import SubscriptionTransactionInfoComponent from './subscription-transaction-info.component';
import SubscriptionBusinessInfoComponent from './subscription-business-info.component';
import SubscriptionAddressInfoComponent from './subscription-address-info.component';
import ProgramDetails from '../containers/program';

export const SubscriptionsComponent = ({id,subscriptionInfo,handleFormSubmit,programs,handleInnerFormChange,selectedSubscriptions,back}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Basic Information',
        component:<SubscriptionBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        SubscriptionsDetails={selectedSubscriptions}
        programs={programs}
        />,
        isVisible:id == 0? true : false
    },
    {
      id: 2,
      title: 'Business-Info',
      component: (
          <SubscriptionBusinessInfoComponent
          handleInnerFormChange={handleInnerFormChange}
          SubscriptionsDetails={selectedSubscriptions}
          />
      ),
      isVisible:id == 0 ? true : false
  },
  {
    id: 3,
    title: 'Address-Info',
    component: (
        <SubscriptionAddressInfoComponent
        handleInnerFormChange={handleInnerFormChange}
        SubscriptionsDetails={selectedSubscriptions}
        />
    ),
    isVisible:id == 0 ? true : false
},
    {
      id:4,
      title:'Subscription Transaction Information',
      component:<SubscriptionTransactionInfoComponent 
      subscriptionInfo={subscriptionInfo}
      />,
      isVisible:id > 0? true : false
  },
  {
    id:4,
    title:'Program Details',
    component:<ProgramDetails
    subscriptionInfo={subscriptionInfo}
    />,
    isVisible:id > 0? true : false
}
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
              onClick={handleFormSubmit}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Save
             </button>
        </div>
       </div>
  )
}
export default SubscriptionsComponent;
